import React from "react";
import "./style.css";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import { FaLayerGroup, FaHandshake } from "react-icons/fa";
function Expertise(props) {
  return (
    <Row className="justify-content-center">
      <Col md={10}>
        <Row className="align-items-center minHeight-85">
          <Col lg={12} className="Expertise-content">
            <img
              src="/img/Expertise/Shape.png"
              alt="global1"
              className="big-circle"
            />
            <img
              src="/img/Expertise/Shape2.png"
              alt="global1"
              className="big-circle2"
            />
            <h1 id="id_h1Expertise">About Lozrian</h1>

            <p id="id_Lozrian_p">
              Lozrian is a multidisciplinary solutions company that brings
              together technology, business expertise, and international
              supply capabilities under one brand. We partner with businesses
              to develop innovative digital products, support strategic
              growth, and provide reliable sourcing and trading solutions.
              With a commitment to quality, collaboration, and long-term
              partnerships, we help organizations turn ideas into successful
              outcomes.
            </p>
            <div className="Expertise-highlights">
              <div className="Expertise-highlight">
                <div className="OurServicesIcon">
                  <FaLayerGroup />
                </div>
                <div>
                  <h5>Multidisciplinary Expertise</h5>
                  <p>
                    Technology, business, and international supply
                    capabilities brought together under one brand.
                  </p>
                </div>
              </div>
              <div className="Expertise-highlight">
                <div className="OurServicesIcon">
                  <FaHandshake />
                </div>
                <div>
                  <h5>Long-Term Partnerships</h5>
                  <p>
                    Committed to quality, collaboration, and building
                    lasting relationships with every client.
                  </p>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </Col>
    </Row>
  );
}

export default Expertise;
